import { faTriangleExclamation, faMultiply, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { KeycloakUser, UserfulUser } from "../../../model/CarbonExternalModels";
import { deleteUser } from "../../../store/userManagement/userManagementManager";
import { UserPermission } from "../../../model/CarbonPermissionModels";
import { Button, UserfulTooltip } from "userful-chronos-common-ui/dist";

interface IProps {
    user: KeycloakUser;
    type: "DROPDOWN" | "ICON";
    permissions: UserPermission;
}

export default function UserDelete(props: IProps) {
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

    if (props.user.userProfile.userName === "admin" || !props.permissions.isUserSuppressor) return null;

    return (
        <>
            {props.type === "DROPDOWN" ? (
                <Dropdown.Item
                    onClick={() => {
                        setShowConfirmation(true);
                    }}
                >
                    <div className="gcm-icon-dropdown-menu-icon-container">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                    <p>Delete</p>
                </Dropdown.Item>
            ) : (
                <UserfulTooltip title={"Delete"}>
                    <button
                        className="iconButton"
                        onClick={() => {
                            setShowConfirmation(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                </UserfulTooltip>
            )}

            <Modal
                centered
                show={showConfirmation}
                onHide={() => {
                    setShowConfirmation(false);
                }}
            >
                <div className="gcm-pop-up-modal-wrapper">
                    <div className="gcm-pop-up-modal-wrapper-body">
                        <div className="gcm-pop-up-modal-wrapper-head">
                            <div className="gcm-pop-up-modal-wrapper-title">
                                <FontAwesomeIcon icon={faTriangleExclamation} />
                                <h1>Delete User</h1>
                            </div>
                            <Button
                                variant="secondary"
                                iconOnly
                                onClick={() => {
                                    setShowConfirmation(false);
                                }}
                            >
                                <FontAwesomeIcon icon={faMultiply} />
                            </Button>
                        </div>
                        <p>
                            Are you sure you want to delete the user:{" "}
                            <strong>"{props.user.userProfile.userName}"</strong>? This will permanentaly remove all the
                            data related this user.
                        </p>
                    </div>
                    <div className="confirmationDialogHorizontalWrapper reversed">
                        <Button
                            variant="danger"
                            onClick={(e) => {
                                setShowConfirmation(false);
                                deleteUser(props.user.id, "INTERNAL");
                            }}
                        >
                            Delete
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={(e) => {
                                setShowConfirmation(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
